var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { BlueLink } from '@hn-ui/links';
import { GoLink } from '@hn-ui/icons';
import { checkIfStudentRow } from '../tableConfig';
var ScCell = styled.div.withConfig({ displayName: "ScCell", componentId: "sc-1ekn2yt" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  top: 3px;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  top: 3px;\n"])));
export var ReportLinkCell = function (_a) {
    var onLinkClick = _a.onLinkClick, cellProps = __rest(_a, ["onLinkClick"]);
    var original = cellProps.row.original;
    if (!checkIfStudentRow(original))
        return null;
    return (_jsx(ScCell, { children: _jsx(BlueLink, { Icon: GoLink, href: original.timelineLink, onClick: onLinkClick, target: '_blank' }, void 0) }, void 0));
};
var templateObject_1;
